import { CardModel } from './Poker.CardModel';

export class SquareModel {
    
    cardModel: CardModel;
    handRow: number = 0;
    handCol: number = 0;
    score: number = 0;
    
    isAvailable = false;

    constructor(row: number, col: number, cardId: number) {
        this.cardModel = new CardModel(cardId);
        this.handCol = col;
        this.handRow = row;
     }
    
    public get isCard() {
        return (this.cardModel.cardId > 0);
    }
    public get isScore() {
        return (this.score > 0);
    }

    public get imageName() : string {

        let filename = 'blank';

        if (this.score > 0) filename = 'Result_' + this.score.toString().trim();

        return filename;
    }

    /* cardSuitName = getSuitName(this.cardSuit);
    cardNumberName = getNumberName(this.CardNumber);
    public get cardText() : string {
        return this.getSuitName(this.cardSuit) + " " + this.getNumberName(this.cardId);
    } */
}
